module.exports = __webpack_public_path__ + "img/social_responsibility_iamuntaught_book.1b5e2755.jpg";